import { render, staticRenderFns } from "./ChangeBrandPhotoPopup.vue?vue&type=template&id=118156fd&scoped=true&"
import script from "./ChangeBrandPhotoPopup.vue?vue&type=script&lang=ts&"
export * from "./ChangeBrandPhotoPopup.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeBrandPhotoPopup.vue?vue&type=style&index=0&id=118156fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118156fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('118156fd')) {
      api.createRecord('118156fd', component.options)
    } else {
      api.reload('118156fd', component.options)
    }
    module.hot.accept("./ChangeBrandPhotoPopup.vue?vue&type=template&id=118156fd&scoped=true&", function () {
      api.rerender('118156fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ChangeBrandPhotoPopup.vue"
export default component.exports